export const PUBLIC_BETA_NOTICE_LAST_UPDATED = 'August 24, 2026';

export const PUBLIC_BETA_NOTICE_SUPPORT_EMAIL = 'support@verdekai.com';

export const PUBLIC_BETA_NOTICE_PARAGRAPHS = [
  'VerdeKai is in private beta.',
  'VerdeKai is underwriting software for litigation finance. This site is for an invite-only prototype. It is not a commercial product and not a public filing system.',
  'AI helps organize and draft. Judgment stays with the team. The committee owns the decision. The product is not an AI score.',
  'If you write us from this site, we only use the email you send to reply. Testers work with privileged matter data. Do not send files unless we invited you.',
] as const;
